export default "__VITE_ASSET__BqZGey7e__"